import React from 'react';
import { Modal, Button } from "antd";
import "./matchable.scss";
import MiniProgressBar from '../../ProgressBar/MiniProgressBar';
import { TaskCompleteIcon } from '../../../legacy_components/components/common/CustomIcon';
import { PageConstant } from '../../../constants';
import { STATUS } from '../../../legacy_components/constants/status';
import { connect } from 'react-redux';

const Matchable = ({ isProgrammerRole, extraPassedInfo, workExpCompleted, turingProfileCompleted }) => (
    <Modal
        visible={true}
        footer={null}
        width="504px"
        closable={false}
    >
        <div className="matchable">
            <div className="title">
                <div className="text">
                    Congratulations!
                </div>
                <div className="subtext">
                    You have completed our main vetting process and now you are eligible for Jobs.
                </div>
            </div>

            <div className="progressText">
                <TaskCompleteIcon className="icon" />
                <span className="text">Profile Completed!</span>
            </div>

            <MiniProgressBar
                status={STATUS.COMPLETED_PROFILE}
                isProgrammerRole={isProgrammerRole}
                extraPassedInfo={{ ...extraPassedInfo, passedAcc: true }}
                workExpCompleted={workExpCompleted}
                turingProfileCompleted={true}
                invertColors
            />

            <p className="description">
                Here are some things you can do to keep making your profile more attractive to our business partners:
                <ul>
                    <li>Keep your Work Availability & Profile up to date</li>
                    <li>Complete at least one extra Tech Stack.</li>
                    <li>Take Additional Relevant Tests.</li>
                </ul>
            </p>

            <Button type="primary" className="button" href={PageConstant.DASHBOARD_DEV}>Go to the Home Dashboard</Button>
        </div>
    </Modal>
);

const mapStateToProps = (state) => {
    return Object.assign(
        {},
        { extraPassedInfo: state.home.extraPassedInfo },
        { isProgrammerRole: state.home.isProgrammerRole },
        { workExpCompleted: state.home.workExpCompleted },
        { turingProfileCompleted: state.tests.turingProfileCompleted },
    );
};

export default connect(
    mapStateToProps,
    null
)(Matchable);

